import $ from 'jquery'
// import Cart from './cart.js'

export default () => {
  const nodeSelectors = {
    container: '[js-product-card="container"]',
  }

  function init() {
    
    if (!$(nodeSelectors.container).length) {
      return
    }

    initProductCard()
  }

  function initProductCard() {
    
    $('.product-card .single-color').hover(function(){
      let selectedImage = $(this).data('image');
      $(this).parent().parent().parent().find('.single-color').removeClass('active')
      $(this).addClass('active')
      $(this).parent().parent().parent().find('.image-holder img').attr('srcset', selectedImage);
    })

    $('.product-card .single-color').on('click', function(e){
        e.preventDefault();
        window.open($(this).data('url'), "_self")
    })
  }

  return Object.freeze({
    init
  })
}
